import { render, staticRenderFns } from "./wx-open-launch-app.vue?vue&type=template&id=de04eed4&scoped=true&"
import script from "./wx-open-launch-app.vue?vue&type=script&lang=js&"
export * from "./wx-open-launch-app.vue?vue&type=script&lang=js&"
import style0 from "./wx-open-launch-app.vue?vue&type=style&index=0&id=de04eed4&lang=stylus&scoped=true&"
import style1 from "./wx-open-launch-app.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de04eed4",
  null
  
)

export default component.exports